export default __webpack_public_path__ + "static/large-datasets-65472752c477ef732c11c8123f7a70dc.png";